// import React from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css";
// import App from "./App";
// import { BrowserRouter } from "react-router-dom";

// import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// const queryClient = new QueryClient();

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <React.StrictMode>
//     <QueryClientProvider client={queryClient}>
//       <BrowserRouter>
//         <App />
//       </BrowserRouter>
//     </QueryClientProvider>
//   </React.StrictMode>
// );
import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css"; // keep tailwind / global styles

function Maintenance() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-2xl w-full bg-white rounded-xl shadow-xl p-8 text-center">
        <h1 className="text-4xl font-extrabold text-[rgb(250,150,0)] mb-4">
          Przerwa techniczna
        </h1>
        <p className="text-gray-700 mb-6">
          Strona tymczasowo niedostępna z powodu prac technicznych. Wracamy wkrótce.
        </p>
        <div className="text-sm text-gray-600 mb-6">
          Jeśli potrzebujesz pilnego kontaktu:{" "}
          <a
            href="mailto:kontakt@bimup.pl"
            className="text-[rgb(250,150,0)] hover:underline"
          >
            kontakt@bimup.pl
          </a>
        </div>
        <div className="flex justify-center gap-3">
          <a
            href="/status"
            className="px-4 py-2 rounded-lg border border-[rgb(250,150,0)] text-[rgb(250,150,0)] hover:bg-[rgb(250,150,0)] hover:text-white transition"
          >
            Sprawdź status
          </a>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 rounded-lg bg-[rgb(250,150,0)] text-white hover:bg-orange-600 transition"
          >
            Odśwież
          </button>
        </div>
        <p className="text-xs text-gray-400 mt-6">BIMup Academy • Prace serwisowe</p>
      </div>
    </div>
  );
}

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Root element not found (id='root')");
}
createRoot(rootEl).render(<Maintenance />);